/* eslint-disable */
import { ORDERS_FIND_LINKED, ORDERS_FIND_LINKED_COMPLETE, ORDERS_FIND_LINKED_ERROR, ORDERS_FIND_LINKED_SUCCESS } from '../Orders.types';

/**
 * Fetch the linked `orders`
 * @param {OrderServiceFindByStatusDto} dto The required params to find the linked orders
 * @returns {ActionCreator<FromPromise>} The created `Action`
 */
const ordersFindLinked = ({ date, orderCode }) => ({ orderService, fromPromise }) => {
  const promise = orderService.findLinked({ date, orderCode });
  return fromPromise(promise, { params: { date, orderCode } }, [
    ORDERS_FIND_LINKED,
    ORDERS_FIND_LINKED_COMPLETE,
    ORDERS_FIND_LINKED_ERROR,
    ORDERS_FIND_LINKED_SUCCESS,
  ]);
};

export default ordersFindLinked;
